// extracted by mini-css-extract-plugin
module.exports = {"status":"AdjustableStatus_status__3vgNm","icon":"AdjustableStatus_icon__1hnCE"};